import { WATCH_IMAGES, WEBSHEET_TAGS } from '@whistler-ui/k2/constants';

import { TemplateDataType } from '../types';

export const WS_DEFAULT_SETTINGS = {
  [WEBSHEET_TAGS.WS_ESIM_QUICK_TRANSFER]: {
    requires_tc: false,
    requires_subscriber_authentication: false,
  },
  [WEBSHEET_TAGS.WS_WATCH_ACTIVATE]: {
    requires_tc: false,
    requires_subscriber_authentication: false,
    requires_watch_transfer_tc: false,
    watch_image_url: '',
  },
  [WEBSHEET_TAGS.WS_VOWIFI_ACTIVATE]: {
    requires_tc: false,
    requires_subscriber_authentication: false,
    emergency_address: '',
  },
} as const;

export const PREVIEW_WEB_SHEET = {
  settings: {
    watch_image_url: WATCH_IMAGES.watch3.name,
  },
  localisations: [
    {
      locale: 'en-us',
      data: {
        't&c': {
          title: 'Terms and Conditions',
          agree: 'Agree',
          disagree: 'Disagree',
          content: [
            {
              type: 'numbered-list',
              children: [
                {
                  type: 'numbered-list',
                  children: [
                    {
                      type: 'list-item',
                      children: [
                        {
                          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,  Non consectetur a erat nam at lectus urna duis convallis. In est ante in nibh mauris cursus mattis molestie',
                        },
                      ],
                    },
                    {
                      type: 'list-item',
                      children: [
                        {
                          text: 'Sit amet, consectetur adipiscing elit, Non consectetur a erat nam at lectus urna duis convallis. In est ante in nibh mauris cursus mattis molestie',
                        },
                      ],
                    },
                    {
                      type: 'list-item',
                      children: [
                        {
                          text: 'Dolor sit amet, consectetur adipiscing elit, et dolore magna aliqua. Non consectetur a erat nam at lectus urna duis convallis. In est ante in nibh mauris cursus mattis molestie',
                        },
                      ],
                    },
                    {
                      type: 'list-item',
                      children: [
                        {
                          text: 'Lectus urna duis convallis. In est ante in nibh mauris cursus mattis molestie, dolor sit amet, consectetur adipiscing elit, et dolore magna aliqua',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        watch: {
          title: `Watch Template`,
          content: [
            {
              type: 'paragraph',
              children: [
                {
                  text: 'Your voice and data will be shared with the subscriber’s mobile service plan.',
                },
              ],
            },
          ],
        },
      },
    },
  ],
};

export const PREVIEW_WEBSHEET_TEXT = {
  title: undefined,
  content: [
    {
      type: 'paragraph',
      children: [{ text: 'Preview Websheet description' }],
    },
  ],
  disclaimer: [
    {
      type: 'paragraph',
      children: [{ text: 'Preview Websheet information' }],
    },
  ],
};

export const WEBSHEET_BRANDING_CONTENT = [
  {
    type: 'paragraph',
    children: [{ text: 'This is a paragraph example:' }],
  },
  {
    type: 'paragraph',
    children: [
      {
        text: 'Lorem ipsum dolor sit amet consectetur. Dictum ultrices neque etiam elit. Imperdiet tortor in aliquam nullam nam. Nullam mattis eget adipiscing scelerisque.',
      },
    ],
  },
  {
    type: 'paragraph',
    children: [
      {
        text: 'Nisl bibendum rutrum pretium convallis pharetra diam lectus nulla tincidunt. Imperdiet tortor in aliquam nullam nam.',
      },
    ],
  },
];

export const BRANDING_TEMPLATE: TemplateDataType = {
  branding: {
    title: { defaultValue: 'Branding' },
    content: { defaultValue: [] },
    agree: { defaultValue: '' },
    disagree: { defaultValue: '' },
  },
};

export const defaultBrandSettings = {
  name: '',
  slug: '',
  logo_url: '',
  font_config: {
    titles: 'Arial',
    paragraphs: 'Arial',
  },
  color_style_config: {
    paragraph_text: '#3a474e',
    accent_color: '#005F94',
    link_color: '#007BC4',
    button: '#0099CC',
    button_click: '#005F94',
    button_text: '#ffffff',
    background: '#F1F2F3',
    error_dialog: '#CB4141',
    watch_background: '#f0f0f0',
  },
  id: null,
  environment_id: null,
  timestamp: null,
};
